<template>
  <div>
    <CRow class="mb-4">
      <CCol>
        <FilterOption/>
      </CCol>
    </CRow>

    <CRow class="mb-4">
      <CCol>
        <CourseOfInstructors caption="History" icon="cil-layers"/>
      </CCol>
    </CRow>

    <CRow class="mb-4">
      <CCol>
        <Mapping/>
<!--        <MappingReports/>-->
      </CCol>
    </CRow>

<!--    <CRow>-->
<!--      <CCol>-->
<!--        <Mapping/>-->
<!--      </CCol>-->
<!--    </CRow>-->
  </div>
</template>

<script>


import {mapGetters} from 'vuex'
import FilterOption from "@/projects/components/Filter/FilterOption";
import Mapping from "@/projects/views/E-Port/components/Mapping/Mappings";
import CourseOfInstructors from "@/projects/views/E-Port/components/CourseOfInstructors";
import MappingReports from "@/projects/views/E-Port/components/Mapping/MappingReports";


export default {
  name: 'index',
  components: {MappingReports, CourseOfInstructors, Mapping,  FilterOption},
  props:{
    caption:{
      type: String,
      default: ""
    },
    disable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      mapping : {
        type : "",
        item : {}
      },

      dialog:true,
    }


  },

  mounted () {
  },

  created () {
    this.onInit()

  },
  beforeDestroy () {

  },

  methods: {
    onInit(){
    },
  },



  computed:{
    ...mapGetters({
      objsLang : "setting/lang",
    }),
  },

  watch: {

  }

}
</script>
<style >


</style>
